// extracted by css-extract-rspack-plugin
export default {"hero":"HeroContent-module__hero__LvYma","buttons":"HeroContent-module__buttons__vAado"};